<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-card elevation="0" class="rounded-xl" color="secondaryApp">
          <v-card-title>
            {{tituloNovedades}}
          </v-card-title>
          <v-card-text>
            <div class="text--primary">
              {{descripcionNovedades}}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-row justify="center" align-content="center" align="start"> -->
      <v-col
        cols="6"
        xs="6"
        sm="4"
        md="3"
        xl="2"
        lg="2"
        v-for="(item, index) in menu"
        :key="index"
        align-self="start"
      >
        <CardIeaCategory
          :text="item.text"
          :color="user.borrado == '1' && item.validate ? '#dfdfdf' : item.color"
          :icon="item.icon"
          @press="menuAction(item.route, item.validate)"
        />
      </v-col>
      <!-- </v-row> -->
      
    </CardIeaAppMain>
    <br />
  </div>
</template>
<script>
import CardIeaAppMain from "../components/CardIeaAppMain";
import CardIeaCategory from "../components/CardIeaCategory";

export default {
  name: "Home",
  components: {
    CardIeaAppMain,
    CardIeaCategory,
   
  },
  data: () => ({
    tituloNovedades:"",
    descripcionNovedades:"",
    sendvalidation:false,
    menu: [
      {
        text: "Clases",
        icon: require("../assets/categories/10.png"),
        color: "#3a4299",
        route: "Clases",
        validate:false
      },
      {
        text: "Test",
        icon: require("../assets/categories/3.png"),
        color: "#62C542",
        route: "Evaluaciones",
        validate:false
      },
    ],

    panels: [
      { id: 0, text: "Tus Inscripciones a Materias", active: false, data: [] },
      { id: 1, text: "Tus Inscripciones a Exámenes", active: false, data: [] },
      { id: 0, text: "Plan de estudio y classroom", active: false, data: [] },
      { id: 3, text: "Tus Pagos", active: false, data: [] },
      { id: 4, text: "Test Prueba", active: false, data: [] }
    ]
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
    mounted() {
  
  },
  methods: {

    async logout() {
      let that = this;
      await this.$API
        .get({
          url: "alumno/logout",
          data: {}
        })
        .then(() => {
          setTimeout(() => {
            that.$store.dispatch("token", "");
            that.$store.dispatch("user", {});
            that.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    menuAction(route) {
      if (route ){
        if(route == 'Logout'){
          this.logout();
        }else{
          console.log(route);
          this.$router.push({
            name: route
          });  
        }
      }
      
    },
   
  }
};
</script>
